import { GlobalComponents } from '@/components/global-components';
import { Header } from '@/components/header';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <Header />
      {children}
      <GlobalComponents />
    </>
  );
};

export default Layout;
